var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fd-second-main fd-second-main"},[_c('crumbs-nav',{attrs:{"dataList":_vm.crumbsList}}),_vm._v(" "),_c('div')],1)}
var staticRenderFns = []

export { render, staticRenderFns }